import React, { useState, useCallback } from 'react';
import { Redirect } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { clearCache } from '../..';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  Button,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import tokenProvider from '../../utils/token';
import usersService from '../../services/users';

interface Props {}

const HeaderMenu: React.FunctionComponent<Props> = (props) => {
  const [anchor, setAnchor] = useState<Element | null>();
  const [loggedOut, setLoggedOut] = useState(false);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const open = Boolean(anchor);

  const onClose = () => {
    setAnchor(null);
  };

  const onLogout = () => {
    tokenProvider.clearToken();
    clearCache();
    setLoggedOut(true);
  };

  const onChangePassword = useCallback(() => {
    setChangePasswordOpen(true);
    onClose();
  }, []);

  const onClosePassword = useCallback(() => {
    setChangePasswordOpen(false);
  }, []);

  const onSavePassword = useCallback(() => {
    if (password1 === password2) {
      usersService
        .changePassword({ newPassword: password1 })
        .then(() => {
        enqueueSnackbar('Successfully updated password', { variant: 'info', autoHideDuration: 3000 });
        setPassword1('');
        setPassword2('');
        setChangePasswordOpen(false);
      })
        .catch((e) => {
          enqueueSnackbar('Failed to update password', { variant: 'error', autoHideDuration: 3000 });
        });
    } else {
      enqueueSnackbar("Passwords don't match", { variant: 'error', autoHideDuration: 3000 });
    }
  }, [enqueueSnackbar, password1, password2]);

  if (loggedOut) {
    return <Redirect to="/login" />;
  }

  return (
    <div>
      <IconButton
        aria-owns={open ? 'menu-appbar' : undefined}
        aria-haspopup="true"
        onClick={(event) => setAnchor(event.target as Element)}
        color="inherit">
        <AccountCircle />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchor}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={onClose}>
        <MenuItem onClick={onLogout}>Logout</MenuItem>
        <MenuItem onClick={onChangePassword}>Change password</MenuItem>
      </Menu>
      <Dialog
        open={changePasswordOpen}
        onClose={onClosePassword}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">Change password</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Enter the new password. The passwords must match.
          </DialogContentText>
          <TextField
            autoFocus
            margin="normal"
            id="password1"
            fullWidth
            value={password1}
            onChange={(event) => setPassword1(event.target.value)}
            label="Password"
            type="password"
          />
          <br />
          <TextField
            autoFocus
            margin="normal"
            id="password2"
            fullWidth
            value={password2}
            onChange={(event) => setPassword2(event.target.value)}
            label="Password again"
            type="password"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClosePassword} color="secondary">
            Cancel
          </Button>
          <Button onClick={onSavePassword} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HeaderMenu;
